import { useDroppable } from "@dnd-kit/core";
import { useDraggable } from "@dnd-kit/core";
import { CSS } from "@dnd-kit/utilities";
import { GripVertical } from "lucide-react";

function KanbanCard({ item, columnId }) {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        isDragging,
    } = useDraggable({
        id: String(item.id),
        data: { type: "card", columnId, item },
    });

    const style = {
        transform: CSS.Translate.toString(transform),
        opacity: isDragging ? 0.45 : 1,
    };

    const title = item.descripcion ?? item.codigo ?? item.label ?? String(item.id);
    const subtitle = item.codigo && item.descripcion ? item.codigo : item.nota;

    return (
        <div
            ref={setNodeRef}
            style={style}
            className={`bg-white border border-gray-200 rounded-lg p-3 shadow-sm ${isDragging ? "shadow-md ring-2 ring-blue-200" : ""}`}
        >
            <div className="flex items-start gap-2">
                <button
                    type="button"
                    className="mt-0.5 text-gray-400 hover:text-gray-600 cursor-grab active:cursor-grabbing shrink-0"
                    {...listeners}
                    {...attributes}
                >
                    <GripVertical className="h-4 w-4" />
                </button>
                <div className="min-w-0 flex-1">
                    <p className="text-sm font-medium text-gray-900 truncate">{title}</p>
                    {subtitle ? (
                        <p className="text-xs text-gray-500 truncate mt-0.5">{subtitle}</p>
                    ) : null}
                </div>
            </div>
        </div>
    );
}

export default function ColumnKanban({
    columnId,
    title,
    items = [],
    itemCount,
}) {
    const { setNodeRef, isOver } = useDroppable({
        id: `column-${columnId}`,
        data: { type: "column", columnId },
    });

    const count = itemCount ?? items.length;

    return (
        <div
            className={`flex flex-col w-72 shrink-0 bg-gray-50 border border-gray-200 rounded-lg overflow-hidden ${isOver ? "ring-2 ring-blue-300 bg-blue-50/40" : ""}`}
        >
            <div className="px-3 py-2.5 border-b border-gray-200 bg-white">
                <div className="flex items-center justify-between gap-2">
                    <h3 className="text-sm font-semibold text-gray-900 truncate">{title}</h3>
                    <span className="text-xs text-gray-500 bg-gray-100 px-2 py-0.5 rounded-full shrink-0">
                        {count}
                    </span>
                </div>
            </div>
            <div
                ref={setNodeRef}
                className="flex-1 min-h-[280px] max-h-[calc(100vh-320px)] overflow-y-auto p-2 space-y-2"
            >
                {items.length === 0 ? (
                    <div className="flex items-center justify-center h-24 text-xs text-gray-400 border border-dashed border-gray-200 rounded-lg">
                        —
                    </div>
                ) : (
                    items.map((item) => (
                        <KanbanCard key={item.id} item={item} columnId={columnId} />
                    ))
                )}
            </div>
        </div>
    );
}
